import type React from "react";

import { DevState } from "#scripts/lib/dev/DevState.tsx";
import { MountDebugComponent } from "#scripts/lib/dev/MountDebugComponent.tsx";
import { useTodoVM } from "../Root.js";
import { LiveValue } from "./LiveValue.tsx";

export const MainSection: React.FC = () => {
  const vm = useTodoVM();

  return (
    <section data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/MainSection.tsx:12:14" data-name="section" className="todos">
      {/* #hide debugs */}
      <MountDebugComponent
        id="!visibleTodos"
        debugKey="devstate"
        render={<DevState data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/MainSection.tsx:17:27" data-name="DevState" data={vm.itemList.items$} name="" />}
      />
      {/* #endhide debugs */}
      <ul data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/MainSection.tsx:20:11" data-name="ul" className="todo-list">
        <LiveValue query={vm.itemList.items$}>
          {(items) =>
            items.map((item) => (
              <li data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/MainSection.tsx:24:19" data-name="li" key={item.key}>
                <div data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/MainSection.tsx:25:22" data-name="div" className="state">
                  <LiveValue query={item.completed$}>
                    {(completed) => (
                      <input type="checkbox" data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/MainSection.tsx:28:46" data-name="input" className="toggle" checked={completed} onChange={item.toggleCompleted} />
                    )}
                  </LiveValue>
                  <LiveValue query={item.text$}>{(text) => <label data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/MainSection.tsx:31:67" data-name="label">{text}</label>}</LiveValue>
                  <button type="button" data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/MainSection.tsx:32:41" data-name="button" className="destroy" onClick={item.remove} />
                </div>
              </li>
            ))
          }
        </LiveValue>
      </ul>
    </section>
  );
};
